<template>
  <span v-if="canSwitchLocale" class="locale-switch">
    <v-btn class="btn__wider" prepend-icon="language" variant="text" @click="switchLocale">
      <div class="locale-display">{{ t(Words.MenuLanguage) }}</div>
    </v-btn>
    <v-btn class="btn__smaller" icon="language" variant="text"  @click="switchLocale" />
  </span>
</template>

<script lang="ts" setup>

const { t, locale } = useI18n()
const currentMember = useMember()
const switchLocalePath = useSwitchLocalePath()

// 是否能切換語系
const canSwitchLocale = computed(() => {
  if (!currentMember.value) return true
  else return currentMember.value.locales.length > 1
})

function switchLocale() {
  if (locale.value === 'zh') {
    navigateTo(switchLocalePath('en'), { replace: true })
  } else {
    navigateTo(switchLocalePath('zh'), { replace: true })
  }
}

</script>


<style lang="stylus" scoped>
.locale-display
  font-weight bold
.btn__wider
  /deep/ .v-icon
    font-size 18px
@media (max-width: 600px)
  .btn__wider
    display none
@media (min-width: 601px)
  .btn__smaller
    display none
</style>